"use client";

import { usePathname } from "next/navigation";
import { AppHeader } from "@/components/header/AppHeader";
import { LandingHeader } from "@/components/header/LandingHeader";
import { ListHeader } from "@/components/header/ListHeader";

/**
 * @file bidixHeader.tsx
 * @description Context-Aware Header 컨트롤러 컴포넌트
 *
 * 현재 경로(pathname)를 확인하여 적절한 헤더를 렌더링합니다.
 *
 * 헤더 타입:
 * - LandingHeader: 랜딩 페이지 및 마케팅 페이지 (`/`, `/brand-story`)
 * - AppHeader: 앱 페이지 (분석, 시뮬레이션, 대시보드, 가이드 등)
 */

export function BidixHeader() {
  const pathname = usePathname();

  // 랜딩 페이지, 브랜드 스토리 등 '마케팅 페이지' 경로 정의
  const isMarketingPage = pathname === "/" || pathname === "/brand-story";

  // 리스트 페이지 경로 정의
  const isListPage = pathname === "/list";

  // 경로에 따라 다른 헤더 렌더링
  if (isMarketingPage) {
    return <LandingHeader />;
  }

  // 리스트 페이지
  if (isListPage) {
    return <ListHeader />;
  }

  // 그 외 앱 페이지(분석, 시뮬레이션, 대시보드, 가이드 등)
  return <AppHeader />;
}
